<template>
	<div id="logs-request-loading" class="vs-con-loading__container comments">
		<div class="comments__list-item">
			<div v-for="(request, idx) in requests" :key="`log-request-${idx}`" class="pt-4  ">
				<a :href="relationItemLink(request)" class="underline">
					{{ request.created_at | dateTime(userDateTimeFormat) }} - {{ request.reqtype && request.reqtype.name }} - {{ request.request_reason }}
				</a>
			</div>

			<div class="text-center">
				<vs-button :disabled="loading" id="button-logs-requests-loading" v-if="haveMore" class="vs-con-loading__container list-item__btn-loadmore" @click="loadMore">
					{{ $t("More") }}
				</vs-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "LogsRequestByRelations",
	props: {
		relations: {
			type: Array,
			default: () => []
		},
		limit: {
			type: Number,
			default: 5
		},
		requests: {
			type: Array,
			default: () => []
		},
		totalRequests: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			loading: false,
			page: 1
		};
	},
	computed: {
		totalPages() {
			return Math.ceil(this.totalRequests / this.limit);
		},
		haveMore() {
			if (this.page <= this.totalPages) {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		relationItemLink(request) {
			return `${this.$constant.PAGES_PATH.PAGE_CBS_REQUEST_PATH}?id=${request.id}`;
		},
		loadMore() {
			this.loading = true;
			this.$vs.loading({
				container: "#button-logs-requests-loading",
				scale: 0.6
			});

			this.$emit("onLoadMoreLogsRequest", { limit: this.limit, page: this.page, relations: this.relations, orderBy: { column: "created_at", direction: "desc" } });
		},
		finishedLoadMore() {
			this.page = this.page + 1;
			this.loading = false;
			this.$vs.loading.close("#button-logs-requests-loading > .con-vs-loading");
		}
	}
};
</script>
